import { render, staticRenderFns } from "./AreaReactView.vue?vue&type=template&id=0275cf0b&scoped=true"
import script from "./AreaReactView.vue?vue&type=script&lang=js"
export * from "./AreaReactView.vue?vue&type=script&lang=js"
import style0 from "./AreaReactView.vue?vue&type=style&index=0&id=0275cf0b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0275cf0b",
  null
  
)

export default component.exports